<template>
  <div class="content">
    <div class="location">
      <p class="text">500 W. Broadway</p>
      <p class="text">San Diego, CA, 92101</p>
      <p class="text">PHONE <a href="tel:6197956000">619.795.6000</a></p>
      <p class="text">FAX <a href="tel:6197956600">619.795.6600</a></p>
      <p class="text">
        <a target="_blank" rel="noopener" href="https://theguildhotel.com"
          >theguildhotel.com</a
        >
      </p>
    </div>
    <div class="codes">
      <p class="text" v-for="(code, index) in codes" :key="index">
        {{ code }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Content",
  data() {
    return {
      codes: [
        `MARSHA    |  SANTX`,
        `SABRE     | 325371`,
        `APOLLO    |  F2026`,
        `WORLDSPAN |  SANTX`,
        `AMADEUS   | SANTXU`
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.content {
  // border: 1px solid green;
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: space-around;
}

.location {
  // border: 1px solid red;
  text-align: left;
}

.codes {
  // border: 1px solid blue;
  text-align: right;
}

.text {
  margin: 0.25rem;
  font: normal 1.5rem $courier;
  color: #c2a853;
  opacity: 1;
}

.text > a {
  color: $gold;
  text-decoration: none;
}

.text:first-of-type {
  margin-top: 0;
}

.text:last-of-type {
  margin-bottom: 0;
}

.codes > .text {
  white-space: pre;
  margin-right: 0;
}

@media screen and (max-width: 1366px) {
  .content {
    flex-direction: column;
  }

  .location,
  .codes {
    text-align: center;
    margin: 1rem 0;
  }
}
</style>
